import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-049b7762"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organization-listing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "organization-listing__all-users" }, "Все врачи", -1))
const _hoisted_3 = { class: "organization-listing__report-count" }
const _hoisted_4 = { class: "divider" }

import { computed } from 'vue'
import { OrganizationListingType } from '@/shared/types'
import { EOrganizationCard } from '@/entities/EOrganizationCard'
import { useRoute, useRouter } from 'vue-router'
import { declination } from '@/shared/utils'

interface Props {
  organizations: OrganizationListingType
}


export default /*#__PURE__*/_defineComponent({
  props: {
    organizations: null
  },
  setup(__props: any) {

const props = __props as {
  organizations: OrganizationListingType
}



const router = useRouter()
const route = useRoute()

const isOrganizationsPage = computed(() =>
  route.path.includes('/organizations')
)

const activeOrganizationId = computed(() =>
  route.params.organizationId === 'all'
    ? 0
    : Number(route.params.organizationId)
)

const signature = computed(() =>
  declination(props.organizations.usersCount, ['врач', 'врача', 'врачей'])
)

const handleChooseOrganization = (organizationId: number): void => {
  if (isOrganizationsPage.value) {
    router.push({
      name: 'OrganizationStatisticPage',
      params: { organizationId },
    })
  } else {
    router.push({
      name: 'UserPage',
      params: {
        organizationId: organizationId !== 0 ? organizationId : 'all',
      },
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isOrganizationsPage))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "organization-listing__item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChooseOrganization(0)))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([{
          'organization-listing__item-content--active':
            _unref(activeOrganizationId) === 0,
        }, "organization-listing__item-content"])
          }, [
            _hoisted_2,
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.organizations.usersCount) + " " + _toDisplayString(_unref(signature)), 1)
          ], 2),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_divider)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.organizations.organizations, (organization) => {
      return (_openBlock(), _createBlock(_unref(EOrganizationCard), {
        key: organization.id,
        active: _unref(activeOrganizationId) === organization.id,
        organization: organization,
        onClick: ($event: any) => (handleChooseOrganization(organization.id))
      }, null, 8, ["active", "organization", "onClick"]))
    }), 128))
  ]))
}
}

})